import *as React from "react";
import _ from "lodash";
import {connect} from "react-redux";

interface Props {
    count: number
    style: object;
}

class RadialSeparators extends React.Component<Props> {
    render(): React.ReactNode {
        return _.range(this.props.count).map(index => (
            <Separator key={index} turns={index * (1 / this.props.count)} style={this.props.style}/>
        ));
    }
}

function Separator(props: any) {
    return (
        <div
            style={{
                position: "absolute",
                height: "100%",
                transform: `rotate(${props.turns}turn)`
            }}
        >
            <div style={props.style}/>
        </div>
    );
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        count: ownProps.count,
        style: ownProps.style
    }
};

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(RadialSeparators)



// WEBPACK FOOTER //
// ./app/components/common/RadialSeparators.tsx